import React, { forwardRef } from 'react'
import { MessageEditor } from 'components/UI'
import TagsOption from './TagsOption'

const Editor = ({
  setRef,
  email,
  editorState,
  editorStateChangeHandler,
  getTagsHandler,
  tagLoading,
  tags,
  ...props
}) => {
  return (
    <MessageEditor
      editorRef={setRef}
      editorState={editorState}
      onEditorStateChange={editorStateChangeHandler}
      toolbarCustomButtons={
        tags
          ? [
              <TagsOption
                key={0}
                emailId={email.id}
                getTagsHandler={getTagsHandler}
                loading={tagLoading}
                tags={tags}
              />,
            ]
          : undefined
      }
      toolbar={{
        options: [
          'inline',
          'blockType',
          'fontSize',
          'fontFamily',
          'list',
          'history',
          'emoji',
          'image',
        ],
        inline: {
          options: ['bold', 'italic', 'underline', 'strikethrough'],
        },
        list: {
          options: ['unordered', 'ordered'],
        },
      }}
      {...props}
    />
  )
}

export default forwardRef((props, ref) => <Editor {...props} setRef={ref} />)
